/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';


export interface IIntrumentsList {
    id: number,
    dam_id: number,
    name: string,
    utm_ew: string,
    utm_ns: string,
    disabel: string,
    type: string
}

export interface IInstrumento {
    desabilitado: boolean;
    diametro_tubo: number | null;
    elevacao: number | null;
    elevacao_boca: number | null;
    elevacao_fundo: number | null;
    elevacao_terreno: number | null;
    formula_leitura: string | null;
    freq_monit: number | null;
    freq_monit_medida: string | null;
    id_barragem?: string;
    id_empresa?: string;
    inclinacao: number | null;
    insert_date?: string | null;
    latitude?: number | null;
    limite_faixa_amarela: number | null;
    limite_faixa_amarela_y: number | null;
    limite_faixa_amarela_z: number | null;
    limite_faixa_laranja: number | null;
    limite_faixa_laranja_y: number | null;
    limite_faixa_laranja_z: number | null;
    limite_faixa_verde: number | null;
    limite_faixa_verde_y: number | null;
    limite_faixa_verde_z: number | null;
    limite_faixa_vermelha: number | null;
    limite_faixa_vermelha_y: number | null;
    limite_faixa_vermelha_z: number | null;
    longitude?: number | null;
    motivo_desabilitado: string | null;
    nome: string;
    projecao: string | null;
    responsavel_id: string;
    status: string | null;
    tamanho_icone: number | null;
    tipo: string | null;
    tipo_instrumento: string;
    unidade_medida: string | null;
    update_date?: string | null;
    utm_ew: number | null;
    utm_ns: number | null;
    utm_zone?: number | null;
    uuid?: string;
    cor_icone?: string | null,
    id_icone?: string | null,
    icone?: string;
  }

const get = async (uuid:string): Promise<IInstrumento[] | Error> => {
    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./instrumentos?uuid=${uuid}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao listar registros.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro na requisição de listagem.');
    }
};

const create = async (uuid: string, data: IInstrumento): Promise<any | Error> => {

    await AuthService.verify();
    
    try {
    
        const token = await AuthService.getAccessToken();
    
        const response = await ApiBack.post(`./instrumento?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}` 
            }
        });
    
        if (response.data) {
            return response ;
        }
    
        return new Error('Erro ao criar novo instrumento');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar instrumento');
        }
    }
};

const upgrade = async(uuid: string, data: IInstrumento): Promise<any | Error> => {
    
    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`./instrumento?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }
        
        return new Error('Falha ao atualizar instrumento');
    } catch (error) {
        return new Error((error as { menssage: string}).menssage || 'Error ao atualizar instrumento');
    }
};

const getById = async(uuid: string): Promise<IInstrumento | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get('./instrumento', {
            params: {
                'uuid': uuid
            },
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao buscar instrumento');
    } catch (error) {
        return new Error((error as { message: string }).message || 'Erro ao buscar instrumento');
    }
};

const getSpreadsheet = async(typeInstrument: string): Promise<AxiosResponse> => {

    await AuthService.verify();

    const token = await AuthService.getAccessToken();

    const response = await ApiBack.get(`/leituras/planilhas?tipo=${typeInstrument}`, {
        headers: {
            Authorization: `${token}`
        },
        responseType: 'blob',
    });

    return response;

};

const saveSpreadsheet = async (idInstrument: string, spreadsheet: File) => {
    await AuthService.verify();

    const token = await AuthService.getAccessToken();

    const formData = new FormData();
    formData.append('file', spreadsheet);

    const response = await ApiBack.post(`/leituras/planilhas?uuid=${idInstrument}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `${token}`
        }
    });

    return response;
};


export const InstrumentsServices = {
    get,
    create,
    upgrade,
    getById,
    getSpreadsheet,
    saveSpreadsheet
};
